// extracted by mini-css-extract-plugin
module.exports = {"loader":"_39lwk","checkmark":"_2Ronx","error":"_15aI4","spinner":"_1Dce8","spin":"_3ba5D","large":"_2eVtc","small":"_22-um","white":"wSYE4","blue":"_22wCx"};